import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';

// Ottieni l'elemento DOM per il rendering
const rootElement = document.getElementById('root');

if (rootElement) {
  // Verifica se la pagina è pre-renderizzata da react-snap
  if (rootElement.hasChildNodes()) {
    // Hydrate per contenuto pre-renderizzato (react-snap)
    hydrateRoot(rootElement, 
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    // Render normale per sviluppo
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
} else {
  console.error("Elemento con ID 'root' non trovato. Controlla il tuo HTML.");
}
